import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';

const refreshToken = sessionStorage.getItem('refreshToken');

const asanImzaService = async (data: {
  data: { action: string; form_id?: string };
  url: string;
}): Promise<any> => {
  try {
    const result = await httpClient.post<any>(data.url, data.data);

    return result;
  } catch (err: any) {
    if (err?.response.status === 400) {
      return err?.response.data;
    }

    if (err?.response?.status === 401) {
      window.location.href = 'login';
      sessionStorage.clear();
    }
    if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
      try {
        const result = await httpClient.post<any>(
          `/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`
        );
        // refetchGetHeaderAndMenu();

        sessionStorage.setItem('refreshToken', result.refresh_token);

        window.location.href = 'home-page';
      } catch (errRefresh: any) {
        if (errRefresh?.response.status === 401) {
          window.location.href = 'login';
          sessionStorage.clear();
        }
      }
    }
  }
};

export const useAsanImzaService = () => {
  const {
    isLoading: isLoadingAsanImza,
    data: dataAsanImza,
    mutate: asanImzaMutation,
    isError: isErrorAsanImza,
  } = useMutation(
    ['asanImza'],
    (data: { data: { action: string; form_id?: string; stage?: string }; url: string }) =>
      asanImzaService(data)
  );

  return { isLoadingAsanImza, dataAsanImza, asanImzaMutation, isErrorAsanImza };
};
